import { Injectable, inject } from '@angular/core'
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { EMPTY, Observable } from 'rxjs'
import { AuthState } from '../../store/auth/auth.state'
import { isAccessTokenExpired } from '../helpers/is-access-token-expired'
import {
  IS_TOKEN_REQUIRED_API,
  isPublicApiUrl
} from '../tokens/request-token-context'

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {
  private readonly authState = inject(AuthState)

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const token = this.authState.accessToken()
    if (req.url.indexOf('amazonaws') !== -1) {
      return next.handle(req)
    }

    const isTokenRequired =
      !isPublicApiUrl(req.url) && req.context.get(IS_TOKEN_REQUIRED_API)

    if (token) {
      if (isTokenRequired && isAccessTokenExpired(token)) {
        console.warn('api was called with expired token')
        return EMPTY
      }
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      })
    }
    if (isTokenRequired && !token) {
      console.warn('api was called without token when required')
      return EMPTY
    }
    return next.handle(req)
  }
}
